// ==========================================================================
// PWA Install - TypeScript types + backup listener
// The PRIMARY capture happens in index.html (inline script, runs synchronously
// before ES modules). This module provides TS types and a backup listener.
// ==========================================================================

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

declare global {
  interface Window {
    __pwaInstallPrompt: BeforeInstallPromptEvent | null;
  }
}

// Backup listener — if the inline script missed the event for any reason,
// this will also capture it. Multiple listeners are fine; both just set
// the same global.
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e as BeforeInstallPromptEvent;
});
